import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TrailerModal from '../TrailerModal';

// The release board: what's hot across the network right now and rolling
// into more markets. Honest framing - StarView programs per-country screens
// weekly, so "coming soon" here means trending worldwide and arriving on
// more country screens, not studio release dates we don't control.
const API_BASE = 'https://api.starviewcinema.com';

export default function ComingSoon() {
  const [movies, setMovies] = useState(null);
  const [trailer, setTrailer] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/movies/trending?limit=18`)
      .then((r) => r.json())
      .then((d) => {
        const list = d.movies || d.trending || d.results || [];
        setMovies(Array.isArray(list) ? list : []);
      })
      .catch(() => setMovies([]));
  }, []);

  return (
    <main style={{ minHeight: '70vh', background: '#0b0c1e', color: '#fff', padding: '110px 20px 60px' }}>
      <div style={{ maxWidth: 1060, margin: '0 auto' }}>
        <p style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#CFAA41', fontWeight: 700 }}>Release board</p>
        <h1 style={{ margin: '4px 0', fontSize: 30 }}>Trending now · arriving in more markets weekly</h1>
        <p style={{ opacity: 0.7, maxWidth: 620 }}>
          The films audiences across 199 StarView markets are watching most right now. New titles roll onto
          country screens every week.
        </p>
        {movies == null ? <p style={{ opacity: 0.6 }}>Loading…</p>
          : movies.length === 0 ? <p style={{ opacity: 0.7 }}>The board is being reprogrammed - check back shortly.</p>
          : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 18, marginTop: 22 }}>
              {movies.map((m) => (
                <div key={m.moviePublicId || m._id} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, overflow: 'hidden' }}>
                  {m.moviePoster || m.movieImage ? (
                    <img src={m.moviePoster || m.movieImage} alt={m.movieTitle} style={{ width: '100%', aspectRatio: '2/3', objectFit: 'cover', display: 'block' }} />
                  ) : <div style={{ aspectRatio: '2/3', background: '#181a33' }} />}
                  <div style={{ padding: '10px 12px' }}>
                    <strong style={{ fontSize: 14, display: 'block', minHeight: 36 }}>{m.movieTitle}</strong>
                    <div style={{ opacity: 0.6, fontSize: 12, margin: '2px 0 8px' }}>
                      {m.country}{m.audienceScore > 0 && m.audienceVotes >= 5 ? ` · ★ ${Math.round(m.audienceScore * 10)}%` : ''}
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {m.trailerUrl && (
                        <button onClick={() => setTrailer({ title: m.movieTitle, src: m.trailerUrl })}
                          style={{ background: 'transparent', color: '#38BDF8', border: '1px solid rgba(56,189,248,0.5)', borderRadius: 999, padding: '5px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 700 }}>
                          ▶ Trailer
                        </button>
                      )}
                      <Link to={`/Showtimes?movieId=${m.moviePublicId}`}
                        style={{ background: '#CFAA41', color: '#141021', borderRadius: 999, padding: '5px 12px', fontSize: 12, textDecoration: 'none', fontWeight: 800 }}>
                        Tickets
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>
      {trailer && <TrailerModal title={trailer.title} src={trailer.src} onClose={() => setTrailer(null)} />}
    </main>
  );
}
